import { render, staticRenderFns } from "./Update-Billing.vue?vue&type=template&id=b4ab760e"
import script from "./Update-Billing.vue?vue&type=script&lang=js"
export * from "./Update-Billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports